/**
 * Checks if VAT ID is in format of a valid EU VAT ID.
 */ function isEuVatIdSyntax(vatId) {
    if (!vatId) {
        return false;
    }
    return /^[A-Za-z]{2,4}(?=.{2,12}$)[-_\s0-9]*(?:[a-zA-Z][-_\s0-9]*){0,2}$/.test(vatId);
}
/**
 * Checks if company identification number (UID) of a Swiss company uses the standard format.
 */ function isSwitzerlandCompanyIdentificationNumberSyntax(companyIdentificationNumber) {
    if (!companyIdentificationNumber) {
        return false;
    }
    return /^CHE-([0-9]{3})\.([0-9]{3})\.([0-9]{3})$/.test(companyIdentificationNumber);
}
/**
 * Checks if a tax number (Steuernummer) for EU countries uses a commonly accepted format.
 * Based on Wikipedia: https://de.wikipedia.org/wiki/Steuernummer
 *
 * Accepts various formats:
 * - Purely numeric (e.g., German unified 12-13 digit format: 289381508152)
 * - Numeric with separators (e.g., German old format: 93/815/08152)
 * - Alphanumeric (e.g., Italian codice fiscale, Spanish NIF/NIE)
 * - Length: 3-25 characters (allowing for various EU country formats)
 */ function isEuTaxNumberSyntax(taxNumber) {
    if (!taxNumber || taxNumber.trim().length === 0) {
        return false;
    }
    // Allow purely numeric, alphanumeric, and formats with common separators
    // Minimum 3 chars (e.g., short numeric codes), maximum 25 (e.g., Italian codice fiscale is 16, but allow buffer)
    // Must contain at least one alphanumeric character (not just separators)
    const trimmed = taxNumber.trim();
    if (trimmed.length < 3 || trimmed.length > 25) {
        return false;
    }
    // Must contain at least one alphanumeric character
    if (!/[A-Za-z0-9]/.test(trimmed)) {
        return false;
    }
    // Allow alphanumeric characters and common separators (spaces, slashes, dots, hyphens)
    // Must start and end with alphanumeric character (not a separator)
    // This covers: purely numeric (e.g., 289381508152), numeric with separators (e.g., 93/815/08152), and alphanumeric (e.g., Italian codice fiscale)
    // Note: The regex pattern requires start AND end alphanumeric chars. For 2-character inputs like "AB",
    // the middle group `[A-Za-z0-9\s./-]*` matches empty (zero occurrences), leaving both chars for anchors.
    // However, 2-character inputs are already rejected by the length check above (min 3 chars), so this is fine.
    return /^[A-Za-z0-9][A-Za-z0-9\s./-]*[A-Za-z0-9]$/.test(trimmed);
}
export { isEuVatIdSyntax, isSwitzerlandCompanyIdentificationNumberSyntax, isEuTaxNumberSyntax };
